var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Route, Redirect, Switch } from 'react-router-dom';
import cxs from 'cxs/component';
import { mediaQueries } from 'Theme';
import ReportsRoutes from 'modules/Reports';
import { TitleBar } from 'components';
import OperationLines from 'modules/OperationLines';
import TicketCashDesk from 'modules/Reports';
import theme from 'Theme';
import SceneBar from '../components/SceneBar';
import Menu from 'modules/Menu/container/Menu';
import DetailRoutes from '../modules/Detail/DetailRoutes';
let Main = class Main extends Component {
    render() {
        const routes = [].concat.apply([], sections(this.props.store.users.user).map((section) => section.links));
        return (React.createElement(Wrapper, null,
            React.createElement(TitleBar, null),
            React.createElement(Switch, { style: {
                    border: `1px solid ${theme.color.secondary}`,
                } },
                React.createElement(Route, { exact: true, path: "/detail", component: DetailRoutes }),
                React.createElement(Route, { exact: true, path: "/", render: () => React.createElement(Redirect, { to: "/operationlines" }) }),
                routes.map((route, index) => (React.createElement(Route, { key: index, path: route.path, component: route.component })))),
            React.createElement(SceneBar, { style: {
                    position: 'absolute',
                    bottom: 0,
                } })));
    }
};
Main = __decorate([
    inject('store'),
    observer
], Main);
export default Main;
const Wrapper = cxs('div')({
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    [mediaQueries.mobile]: {
        height: '100%',
    },
    // height: '100%'
    height: `calc(100% - ${theme.common.size.bar}px)`,
});
export const sections = (ser) => {
    return [
        {
            name: 'wharehouse',
            links: [
                {
                    name: 'operationlines',
                    path: '/operationlines',
                    component: OperationLines,
                },
                {
                    name: 'detail',
                    path: '/detail',
                    component: DetailRoutes,
                },
                {
                    name: 'menu',
                    path: '/menu',
                    component: Menu,
                },
                {
                    name: 'cashDeskList',
                    path: '/cashDeskList',
                    component: ReportsRoutes,
                },
                {
                    name: 'tickets',
                    path: '/tickets',
                    component: ReportsRoutes,
                },
            ],
        },
        {
            name: 'reports',
            links: [
                {
                    name: 'tickets',
                    path: '/tickets',
                    component: ReportsRoutes,
                },
                {
                    name: 'Cierre de caja',
                    path: '/ticketCashDesk',
                    component: TicketCashDesk,
                },
            ],
        },
    ]
        .filter((section) => section.name)
        .map((section) => (Object.assign(Object.assign({}, section), { links: section.links.filter((link) => link) })));
};
// .map(section => ({
//   ...section,
//   links: section.links.map(link => ({
//     ...link,
//     path: '/' + section.name + link.path
//   }))
// }))



//////////////////
// WEBPACK FOOTER
// ./src/scenes/Main.tsx
// module id = 105
// module chunks = 0